import { Brick } from "../../settings/models/brick.model";

export class Branch {
  id: number;
  name: string;
  brickId: number;
  brick: Brick
}
